import React, { useState } from "react";

// Matches the tracker's baked-in ANALYTICS_ORIGIN (see ads_classified_api's
// tracking.routes.js) — /t.js there is served statically with no query-param
// handling, so the site id MUST come via the `data-site` attribute, not a
// `?s=` query string on the script src.
const ORIGIN = "https://adsclassifieds.way2news.co";

function buildSnippet(siteId) {
  return `<script async data-site="${siteId}" src="${ORIGIN}/t.js"></script>`;
}

// Hand-built spans instead of a generic HTML tokenizer — the snippet's shape
// is fixed and fully known, so there's nothing to actually parse.
function HighlightedSnippet({ siteId }) {
  return (
    <pre className="bg-[#1e1e1e] text-gray-200 text-sm rounded-lg p-4 overflow-x-auto font-mono leading-relaxed whitespace-pre-wrap break-all">
      <span className="text-gray-400">{"<"}</span>
      <span className="text-sky-400">script</span>{" "}
      <span className="text-cyan-300">async</span>{" "}
      <span className="text-cyan-300">data-site</span>
      <span className="text-gray-400">=</span>
      <span className="text-orange-300">{`"${siteId}"`}</span>{" "}
      <span className="text-cyan-300">src</span>
      <span className="text-gray-400">=</span>
      <span className="text-orange-300">{`"${ORIGIN}/t.js"`}</span>
      <span className="text-gray-400">{"></"}</span>
      <span className="text-sky-400">script</span>
      <span className="text-gray-400">{">"}</span>
    </pre>
  );
}

function GenerateScriptTab() {
  const [input, setInput] = useState("");
  const [siteId, setSiteId] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleGenerate = () => {
    const trimmed = input.trim();
    if (!trimmed) return;
    setSiteId(trimmed);
    setCopied(false);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(buildSnippet(siteId));
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="max-w-2xl">
      <div className="bg-white border border-gray-200 rounded-lg p-4 mb-4">
        <label className="mb-1 text-sm font-semibold text-gray-600 block">Site ID</label>
        <div className="flex gap-2">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleGenerate()}
            placeholder="e.g. demo-shop.example.com"
            className="border rounded px-3 py-2 w-full text-sm"
          />
          <button
            type="button"
            disabled={!input.trim()}
            onClick={handleGenerate}
            className={`px-4 py-2 rounded text-sm font-semibold whitespace-nowrap ${
              input.trim() ? "bg-sky-600 text-white hover:bg-sky-700" : "bg-gray-100 text-gray-400 cursor-not-allowed"
            }`}
          >
            Generate
          </button>
        </div>
      </div>

      {siteId && (
        <div className="bg-white border border-gray-200 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-semibold text-gray-600">Add this script to your main root/index file</span>
            <button
              type="button"
              onClick={handleCopy}
              className="px-3 py-1.5 rounded text-sm font-semibold bg-emerald-600 text-white hover:bg-emerald-700"
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
          <HighlightedSnippet siteId={siteId} />
        </div>
      )}
    </div>
  );
}

export default GenerateScriptTab;
